/* Bivo theme scripts — no dependencies */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* Mobile drawer */
  function initDrawer() {
    var drawer = $('[data-drawer]');
    if (!drawer) return;
    var openers = $$('[data-drawer-open]');
    function set(open) {
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.body.classList.toggle('no-scroll', open);
      openers.forEach(function (b) { b.setAttribute('aria-expanded', open); });
    }
    openers.forEach(function (b) { b.addEventListener('click', function () { set(true); }); });
    $$('[data-drawer-close]', drawer).forEach(function (b) { b.addEventListener('click', function () { set(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
  }

  /* Search panel */
  function initSearch() {
    var t = $('[data-search-toggle]'), p = $('[data-search-panel]');
    if (!t || !p) return;
    t.addEventListener('click', function (e) {
      e.preventDefault();
      p.hidden = !p.hidden;
      if (!p.hidden) { var i = $('input[type=search]', p); i && i.focus(); }
    });
  }

  /* Announcement rotator (mobile) */
  function initRotator() {
    $$('[data-rotator]').forEach(function (el) {
      var items = $$('.announcement__item', el);
      if (items.length < 2) return;
      var i = 0, ms = parseInt(el.getAttribute('data-interval'), 10) || 4000;
      setInterval(function () {
        if (window.matchMedia('(min-width: 990px)').matches) return;
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, ms);
    });
  }

  /* Reveal on scroll */
  function initReveal() {
    var els = $$('[data-reveal]');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* Help center live search: filters FAQ items across the page */
  function initHelpSearch() {
    $$('[data-help-search]').forEach(function (input) {
      var scope = document;
      var empty = $('[data-help-empty]');
      input.addEventListener('input', function () {
        var q = input.value.trim().toLowerCase();
        var any = false;
        $$('[data-faq-group]', scope).forEach(function (g) {
          var shown = 0;
          $$('.faq__item', g).forEach(function (it) {
            var hit = !q || it.textContent.toLowerCase().indexOf(q) > -1;
            it.style.display = hit ? '' : 'none';
            if (hit) shown++;
            if (q && hit) it.open = true;
            if (!q) it.open = false;
          });
          g.style.display = shown ? '' : 'none';
          if (shown) any = true;
        });
        $$('[data-hide-on-search]').forEach(function (el) { el.style.display = q ? 'none' : ''; });
        if (empty) empty.style.display = any ? 'none' : 'block';
      });
      var form = input.closest('form');
      form && form.addEventListener('submit', function (e) { e.preventDefault(); var f = $('[data-faq-group]'); f && f.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
    });
  }

  /* Track order → ParcelPanel */
  function initTrack() {
    $$('[data-track]').forEach(function (root) {
      var base = root.getAttribute('data-track-url') || '/apps/parcelpanel';
      var tabs = $$('[data-track-tab]', root);
      var panes = $$('[data-track-pane]', root);
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var k = tab.getAttribute('data-track-tab');
          tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); t.setAttribute('aria-selected', t === tab); });
          panes.forEach(function (p) { p.hidden = p.getAttribute('data-track-pane') !== k; });
        });
      });
      $$('form', root).forEach(function (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var err = $('[data-track-error]', root);
          var mode = form.getAttribute('data-mode');
          var url;
          if (mode === 'order') {
            var order = (form.order.value || '').replace(/#/g, '').trim();
            var email = (form.email.value || '').trim().toLowerCase();
            if (!order || !email) { if (err) { err.hidden = false; err.textContent = 'Please enter both your order number and email.'; } return; }
            var token = email.split('').reverse().join('').replace('@', '_-_');
            url = base + '?order=' + encodeURIComponent(order) + '&token=' + encodeURIComponent(token);
          } else {
            var nums = (form.nums.value || '').trim();
            if (!nums) { if (err) { err.hidden = false; err.textContent = 'Please enter your tracking number.'; } return; }
            url = base + '?nums=' + encodeURIComponent(nums);
          }
          if (err) err.hidden = true;
          window.location.href = url;
        });
      });
    });
  }

  /* Countdown (resets daily at midnight local time, or to a fixed date) */
  function initCountdown() {
    $$('[data-countdown]').forEach(function (el) {
      var fixed = el.getAttribute('data-end');
      function tick() {
        var now = new Date(), end;
        if (fixed) { end = new Date(fixed); if (isNaN(end) || end < now) { end = new Date(now); end.setHours(24, 0, 0, 0); } }
        else { end = new Date(now); end.setHours(24, 0, 0, 0); }
        var d = Math.max(0, end - now);
        var h = Math.floor(d / 36e5), m = Math.floor(d % 36e5 / 6e4), s = Math.floor(d % 6e4 / 1e3);
        var pad = function (n) { return (n < 10 ? '0' : '') + n; };
        var H = $('[data-h]', el), M = $('[data-m]', el), S = $('[data-s]', el);
        if (H) H.textContent = pad(h); if (M) M.textContent = pad(m); if (S) S.textContent = pad(s);
      }
      tick(); setInterval(tick, 1000);
    });
  }

  /* Simple product gallery + qty */
  function initProduct() {
    $$('[data-gallery]').forEach(function (g) {
      var main = $('[data-gallery-main] img', g);
      $$('[data-gallery-thumb]', g).forEach(function (b) {
        b.addEventListener('click', function () {
          if (main) { main.src = b.getAttribute('data-src'); main.removeAttribute('srcset'); }
          $$('[data-gallery-thumb]', g).forEach(function (x) { x.classList.toggle('is-active', x === b); });
        });
      });
    });
    $$('[data-qty]').forEach(function (q) {
      var i = $('input', q);
      $$('button', q).forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(i.value, 10) || 1;
          i.value = Math.max(1, v + (b.getAttribute('data-step') === '-' ? -1 : 1));
        });
      });
    });
    $$('[data-variant-select]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var opt = sel.options[sel.selectedIndex];
        var p = document.querySelector('[data-variant-price]');
        if (p && opt.getAttribute('data-price')) p.innerHTML = opt.getAttribute('data-price');
      });
    });
  }

  /* Contact form: prefill subject from ?topic= */
  function initContact() {
    var sel = $('[data-contact-topic]');
    if (!sel) return;
    var m = location.search.match(/[?&]topic=([^&]+)/);
    if (m) {
      var v = decodeURIComponent(m[1].replace(/\+/g, ' ')).toLowerCase();
      Array.prototype.forEach.call(sel.options, function (o) { if (o.value.toLowerCase() === v) sel.value = o.value; });
    }
  }

  /* Footer accordions collapsed on mobile */
  function initFooter() {
    if (window.matchMedia('(max-width: 989px)').matches) {
      $$('.footer__details').forEach(function (d) { d.removeAttribute('open'); });
    }
  }

  /* Live product search on collection pages (searches the whole catalog) */
  function initCatalogSearch() {
    $$('[data-catalog-search]').forEach(function (root) {
      var input = $('[data-catalog-search-input]', root);
      var clear = $('[data-catalog-search-clear]', root);
      var status = $('[data-catalog-search-status]', root);
      var results = $('[data-catalog-search-results]', root);
      var defaultView = document.querySelector('[data-catalog-default]');
      var section = root.getAttribute('data-section');
      var timer, controller, lastQ = '';
      function reset() {
        results.innerHTML = ''; status.textContent = ''; clear.hidden = true;
        if (defaultView) defaultView.hidden = false;
        root.classList.remove('is-loading'); lastQ = '';
      }
      function run(q) {
        if (q === lastQ) return;
        lastQ = q;
        if (controller) controller.abort();
        controller = 'AbortController' in window ? new AbortController() : null;
        root.classList.add('is-loading');
        var url = '/search?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last&section_id=' + encodeURIComponent(section);
        fetch(url, controller ? { signal: controller.signal } : {})
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var wrap = doc.querySelector('[data-count]');
            results.innerHTML = wrap ? wrap.innerHTML : '';
            var n = results.querySelectorAll('.card').length;
            status.textContent = n ? n + (n === 1 ? ' product' : ' products') + ' found for “' + q + '”' : '';
            if (defaultView) defaultView.hidden = true;
            root.classList.remove('is-loading');
          })
          .catch(function (e) { if (e.name !== 'AbortError') { root.classList.remove('is-loading'); } });
      }
      input.addEventListener('input', function () {
        var q = input.value.trim();
        clear.hidden = !input.value;
        clearTimeout(timer);
        if (q.length < 2) { reset(); clear.hidden = !input.value; return; }
        timer = setTimeout(function () { run(q); }, 250);
      });
      input.form.addEventListener('submit', function (e) {
        var q = input.value.trim();
        e.preventDefault();
        if (q.length >= 1) run(q);
      });
      clear.addEventListener('click', function () { input.value = ''; reset(); input.focus(); });
      input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { input.value = ''; reset(); } });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initFooter(); initCatalogSearch(); initDrawer(); initSearch(); initRotator(); initReveal(); initHelpSearch(); initTrack(); initCountdown(); initProduct(); initContact();
  });
})();
